export var RegistrationType;
(function (RegistrationType) {
    RegistrationType["CLIENT"] = "client";
    RegistrationType["TRUST"] = "trust";
    RegistrationType["JOINT"] = "joint";
    RegistrationType["HOUSEHOLD"] = "household";
})(RegistrationType || (RegistrationType = {}));
export var RegistrationStatus;
(function (RegistrationStatus) {
    RegistrationStatus["ACTIVE"] = "active";
    RegistrationStatus["INACTIVE"] = "inactive";
    RegistrationStatus["LEAD"] = "lead";
    RegistrationStatus["ENGAGED"] = "engaged";
})(RegistrationStatus || (RegistrationStatus = {}));
export var RegistrationCreationStepStatus;
(function (RegistrationCreationStepStatus) {
    RegistrationCreationStepStatus["COMPLETE"] = "complete";
    RegistrationCreationStepStatus["INCOMPLETE"] = "incomplete";
    RegistrationCreationStepStatus["SKIPPED"] = "skipped";
})(RegistrationCreationStepStatus || (RegistrationCreationStepStatus = {}));
export var RegistrationActivityType;
(function (RegistrationActivityType) {
    RegistrationActivityType["CREATED"] = "created";
    RegistrationActivityType["STATUS_UPDATED"] = "status_updated";
    RegistrationActivityType["RISK_PROFILE_UPDATED"] = "risk_profile_updated";
    RegistrationActivityType["CUSTOM_PDF_REPORT_GENERATED"] = "custom_pdf_report_generated";
    RegistrationActivityType["TRANSITION_ANALYSIS_GENERATED"] = "transition_analysis_generated";
    RegistrationActivityType["CATEGORIZED_HOLDINGS_GENERATED"] = "categorized_holdings_generated";
})(RegistrationActivityType || (RegistrationActivityType = {}));
export var RegistrationCreateOption;
(function (RegistrationCreateOption) {
    RegistrationCreateOption["REGISTRATION"] = "registration";
    RegistrationCreateOption["HOUSEHOLD"] = "household";
})(RegistrationCreateOption || (RegistrationCreateOption = {}));
export const REGISTRATION_TYPE_LABELS = {
    [RegistrationType.CLIENT]: 'Client Registration',
    [RegistrationType.JOINT]: 'Joint Registration',
    [RegistrationType.TRUST]: 'Trust Registration',
};
export const REGISTRATION_TYPE_LOGOS = {
    [RegistrationType.CLIENT]: 'icon-template-client-registration-color',
    [RegistrationType.JOINT]: 'icon-template-joint-registration-color',
    [RegistrationType.TRUST]: 'icon-template-trust-registration-color',
};
export const REGISTRATION_TYPE_DESCRIPTIONS = {
    [RegistrationType.CLIENT]: 'Single Client',
    [RegistrationType.JOINT]: 'A Joint Account',
    [RegistrationType.TRUST]: 'A Trust Accoiunt',
};
export const CREATE_REGISTRATION_DROPDOWN_OPTIONS = [
    {
        type: 'option',
        label: 'Registration',
        value: RegistrationCreateOption.REGISTRATION,
        icon: 'icon-report',
    },
    {
        type: 'option',
        label: 'Household',
        value: RegistrationCreateOption.HOUSEHOLD,
        icon: 'icon-portfolio-type-household',
    },
];
export const REGISTRATION_STATUS_OPTIONS = [
    { value: RegistrationStatus.ACTIVE, label: 'Active', pillClass: 'bg-positive-8' },
    { value: RegistrationStatus.LEAD, label: 'Lead', pillClass: 'bg-gradient-2d' },
    { value: RegistrationStatus.ENGAGED, label: 'Engaged', pillClass: 'bg-yc-blue-90' },
    { value: RegistrationStatus.INACTIVE, label: 'Inactive', pillClass: 'bg-gray-base-95' },
];
